export default __webpack_public_path__ + "static/empty-cart-a70b3c07ca5660c860a1b1833b715f53.svg";